module.exports = __webpack_public_path__ + "assets/img/item2.e0a8edff.jpg";